module.exports = __webpack_public_path__ + "img/img-2.d69442a5.jpg";